module.exports = __webpack_public_path__ + "img/task_essence@2x.3204d3aa.png";